(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
  // Select the first section tag
var firstSection = document.querySelectorAll('section')[1];

// Remove the padding-top
if (firstSection) {
    firstSection.style.paddingTop = '0';
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = false;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        //this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        //this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeroVideos() {
    var sliders = document.querySelectorAll('.home-slider');

    sliders.forEach(function (slider) {
      if (slider.dataset.heroVideoInitialized === 'true') return;
      slider.dataset.heroVideoInitialized = 'true';

      function getVisibleVideo(slide) {
        if (!slide) return null;

        var videos = slide.querySelectorAll('.hero-video');

        return Array.from(videos).find(function (video) {
          return window.getComputedStyle(video).display !== 'none';
        }) || null;
      }

      function updateButton(slide, paused) {
        var button = slide.querySelector('.hero-video-toggle');
        if (!button) return;

        var playIcon = button.querySelector('.hero-play-icon');
        var pauseIcon = button.querySelector('.hero-pause-icon');

        if (playIcon) playIcon.hidden = !paused;
        if (pauseIcon) pauseIcon.hidden = paused;

        button.setAttribute(
          'aria-label',
          paused ? 'Play video' : 'Pause video'
        );
        button.setAttribute('aria-pressed', String(paused));
      }

      function syncVideos() {
        var slides = slider.querySelectorAll('.owl-item');

        slides.forEach(function (slide) {
          var active = slide.classList.contains('active') &&
                       !slide.classList.contains('cloned');

          var visibleVideo = active ? getVisibleVideo(slide) : null;

          slide.querySelectorAll('video.hero-video').forEach(function (video) {
            if (video !== visibleVideo) {
              video.pause();
            }
          });

          if (!visibleVideo) return;

          var manuallyPaused =
            slide.dataset.heroManuallyPaused === 'true';

          if (manuallyPaused) {
            visibleVideo.pause();
            updateButton(slide, true);
            return;
          }

          visibleVideo.muted = true;
          visibleVideo.playsInline = true;

          var playPromise = visibleVideo.play();

          if (playPromise && typeof playPromise.then === 'function') {
            playPromise.then(function () {
              updateButton(slide, false);
            }).catch(function () {
              updateButton(slide, true);
            });
          }
        });
      }

      slider.addEventListener('click', function (event) {
        var button = event.target.closest('.hero-video-toggle');
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();

        var slide = button.closest('.owl-item');
        var video = getVisibleVideo(slide);

        if (!video) return;

        if (video.paused) {
          slide.dataset.heroManuallyPaused = 'false';
          video.muted = true;

          var promise = video.play();

          if (promise && typeof promise.then === 'function') {
            promise.then(function () {
              updateButton(slide, false);
            }).catch(function () {
              updateButton(slide, true);
            });
          }
        } else {
          slide.dataset.heroManuallyPaused = 'true';
          video.pause();
          updateButton(slide, true);
        }
      });

      if (window.jQuery) {
        var $slider = window.jQuery(slider);

        $slider.on(
          'initialized.owl.carousel translated.owl.carousel refreshed.owl.carousel',
          function () {
            syncVideos();
          }
        );
      }

      window.addEventListener('resize', syncVideos);

      syncVideos();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroVideos);
  } else {
    initHeroVideos();
  }

  document.addEventListener('shopify:section:load', initHeroVideos);
})();

  } catch(e) { console.error(e); }
})();
})();
